import { HttpLink } from 'apollo-link-http';
import { ApolloLink } from 'apollo-link';

import SessionManager from '../../util/sessionManager';

const devToolsHttpLink: ApolloLink = new HttpLink({ uri: SessionManager.urlRouter.devToolsGraphQLUrl });

export default devToolsHttpLink;
